<template>
  <div class="popover bs-popover-auto fade show">
    <div class="popover-body">
      <template v-if="ozonInfo.ozon_price_percent || ozonInfo.actions">
        <p class="mt-4"><b>Информация от Озона</b></p>
        <table class="table table-flush-spacing">
          <tbody>
          <tr v-if="ozonInfo.ozon_price_percent && ozonInfo.ozon_price_percent > 0">
            <td>Цена со скидкой за счет Озона ({{ ozonInfo.ozon_price_percent ? ozonInfo.ozon_price_percent.toFixed(2) : '' }}%)</td>
            <td>{{ calculateOzonPrice() }} {{ currency }}</td>
          </tr>
          <tr v-if="ozonInfo.min_ozon_price">
            <td>Минимальная цена конкурентов на Озоне</td>
            <td>{{ ozonInfo.min_ozon_price }} {{ currency }}</td>
          </tr>
          </tbody>
        </table>
        <template v-if="ozonInfo.actions.length > 0">
          <p class="mt-4">
            <b>Акции</b>
            <i class="ti ti-info-circle action-tooltip-icon" v-tooltip.top="'Отображаются все акции, в которых участвует товар, вне зависимости от доступного остатка в акции'"></i>
          </p>
          <table class="table table-flush-spacing">
            <tbody>
              <tr v-for="action in ozonInfo.actions" :key="action.action_id">
                <td>{{ action.title }}</td>
                <td v-if="action.action_price">{{ action.action_price }} {{ currency }}</td>
              </tr>
            </tbody>
          </table>
        </template>
      </template>
      <template v-if="wbInfo.wb_sale_percent && wbInfo.wb_sale_percent > 0">
        <p class="mt-4"><b>Информация от WB</b></p>
        <table class="table table-flush-spacing">
          <tbody>
          <tr v-if="wbInfo.wb_sale_percent && wbInfo.wb_sale_percent > 0">
            <td>Цена со скидкой за счет WB ({{ wbInfo.wb_sale_percent ? wbInfo.wb_sale_percent.toFixed(2) : '' }}%)</td>
            <td>{{ calculateWbPrice() }} {{ currency }}</td>
          </tr>
          </tbody>
        </table>
      </template>

      <template v-if="showcaseLines.length">
        <p class="mt-4"><b>Цены на витрине</b></p>
        <table class="table table-flush-spacing">
          <tbody>
          <tr v-for="(line, i) in showcaseLines" :key="i">
            <td>{{ line.label }} (−{{ formatPercent(line.percent) }}%)</td>
            <td>{{ formatMoney(line.newPrice) }} {{ currency }}</td>
          </tr>
          </tbody>
        </table>
      </template>

      <p v-if="url" class="mt-3"><a :href="url" target="_blank" @click="hideTooltipCallback"><b>Перейти на карточку</b></a></p>

    </div>
  </div>
</template>

<script>
import Tooltip from 'primevue/tooltip';

export default {
  name: 'MarketplaceTooltip',
  directives: {
    tooltip: Tooltip
  },
  data() {
    return {
      price: 0,
      url: '',
      commissions: {
        percents: [],
        fixed: [],
        percents_with_limit: []
      },
      store_info: [],
      currency: 'Р',
      ozonInfo: {},
      wbInfo: {},
      marketplace: '',
      discountData: null,
      showcaseLines: []
    }
  },
  methods: {
    hideTooltipCallback() {
      if (this.params.hideTooltipCallback) {
        this.params.hideTooltipCallback();
      }
    },
    formatNumber(value, to_fixed = 0) {
      if (!value) return '0';
      value = value.toFixed(to_fixed)
      return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    },
    formatPercent(value) {
      if (value == null || isNaN(value)) return '0'
      return Number(value).toFixed(Number.isInteger(Number(value)) ? 0 : 1)
    },
    formatMoney(value) {
      if (value == null || isNaN(value)) return '0'
      return this.formatNumber(Number(value), 0)
    },
    calculateWbPrice() {
      const originalPrice = this.price;
      const discountPercent = this.wbInfo.wb_sale_percent;
      if (originalPrice && discountPercent > 0) {
        const discountAmount = originalPrice * (discountPercent / 100);
        const discountedPrice = originalPrice - discountAmount;
        return Math.ceil(discountedPrice);
      }
      return '0';
    },
    calculateOzonPrice() {
      const originalPrice = this.price;
      const discountPercent = this.ozonInfo.ozon_price_percent;
      if (originalPrice && discountPercent > 0) {
        const discountAmount = originalPrice * (discountPercent / 100);
        const discountedPrice = originalPrice - discountAmount;
        return Math.ceil(discountedPrice);
      }
      return '0';
    },
    buildShowcaseLines(marketplace, discountData, price) {
      if (!discountData || !discountData.synced_at || !price) {
        return []
      }
      let defaultPercent = null
      let cardPercent = null
      let cardLabel = ''
      if (marketplace === 'wb') {
        defaultPercent = discountData.wb_default_percent
        cardPercent = discountData.wb_card_percent
        cardLabel = 'По карте WB'
      } else if (marketplace === 'ozon') {
        defaultPercent = discountData.ozon_default_percent
        cardPercent = discountData.ozon_card_percent
        cardLabel = 'По карте Ozon'
      } else {
        return []
      }
      const lines = []
      if (defaultPercent > 0) {
        lines.push({
          label: 'Без карты',
          percent: defaultPercent,
          newPrice: price * (1 - defaultPercent / 100)
        })
      }
      if (cardPercent > 0) {
        lines.push({
          label: cardLabel,
          percent: cardPercent,
          newPrice: price * (1 - cardPercent / 100)
        })
      }
      return lines
    }
  },
  beforeMount() {
    const cell = this.params.value
    const store_id = cell.colDef.context.store_id
    const marketplace = cell.colDef.context.marketplace
    this.marketplace = marketplace
    this.price = cell.data[store_id + '_price']

    const offerData = cell.data[store_id] || {}

    if (marketplace === 'ozon') {
      this.ozonInfo = {
        min_ozon_price: offerData.store_info?.['min_ozon_price'],
        actions: offerData.store_info?.['actions'] || [],
        ozon_price_percent: offerData.store_info?.['ozon_price_percent']
      }
    }
    if (marketplace === 'wb') {
      this.wbInfo = {
        wb_sale_percent: offerData.store_info?.['wb_sale_percent']
      }
    }
    this.discountData = offerData.discount_data || null
    this.showcaseLines = this.buildShowcaseLines(marketplace, this.discountData, this.price)
    this.url = offerData.store_url
  },
}
</script>

<style>
.popover {
  max-width: 400px;
  --bs-popover-max-width: 400px;
}

.align-right {
  text-align: right;
}

.table-flush-spacing td:first-child {
  width: 70%;
}

.table-flush-spacing td:last-child {
  width: 30%;
  text-align: right;
}

.action-tooltip-icon {
  margin-left: 8px;
  color: #b0b0b0;
  cursor: pointer;
  font-size: 1.1em;
}

/* Кастом PrimeVue Tooltip */
.p-tooltip {
  max-width: 260px;
  white-space: pre-line;
  word-break: break-word;
  z-index: 99999999 !important;
}

.p-tooltip.p-tooltip-top {
  left: max(8px, var(--p-tooltip-left, 0));
}
</style>
